import { useSetAtom } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { notificationsAtom } from '~//atoms'
import { equalsByPath, type NotificationItem, reject } from '~/utils'

export const useNotify = () => {
  const setNotifications = useSetAtom(notificationsAtom)

  return React.useCallback(
    (params: Omit<NotificationItem, 'timestamp'>) => {
      const timestamp = new Date().getTime()

      setNotifications(R.concat([{ ...params, timestamp }]))

      setTimeout(() => {
        setNotifications(reject(equalsByPath('timestamp', timestamp)))
      }, 10000)
    },
    [setNotifications],
  )
}
